export default __webpack_public_path__ + "static/media/icn-calculator-on.e49914d0.svg";